const getNonEmptyStrings = (...values) => (
  values
    .filter((value) => typeof value === 'string' && value.trim().length > 0)
    .map((value) => value.trim())
)

const getFirstNonEmptyString = (...values) => getNonEmptyStrings(...values)[0] || ''

export const getPreferredContactName = (contact = {}) => (
  getFirstNonEmptyString(contact?.firstName, contact?.first_name, contact?.name)
)

export const getContactDisplayName = (contact = {}) => (
  getFirstNonEmptyString(getPreferredContactName(contact), contact?.email)
)
